module.exports = __webpack_public_path__ + "img/flower_leaf_8.c81bb7a9.png";